"use client";

import { useScheduledTokenRefresh } from "@/hooks/useScheduledTokenRefresh";
export function TokenRefreshScheduler() {
  useScheduledTokenRefresh();
  return null;
}